module.exports = __webpack_public_path__ + "static/media/devPic.1.6ce0912b.jpg";